import React, { useEffect, useState } from 'react';
import { MessageCircleIcon, XIcon, ZapIcon } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead');
    }
  };
  if (!isVisible || isMinimized) return null;
  return <div className="fixed bottom-4 left-0 right-0 z-50 px-4 md:hidden animate-slideUp" data-id="element-49">
      <div className="max-w-sm mx-auto bg-gradient-to-r from-primary to-primaryHover rounded-2xl shadow-2xl border-2 border-white/30 p-3 flex items-center justify-between backdrop-blur-sm animate-pulse hover:animate-none relative overflow-hidden" data-id="element-50">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" data-id="element-51"></div>
        <a href="https://closerdigital.net/F/NLeon1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="flex items-center gap-2.5 text-white font-bold font-poppins text-[14px] uppercase tracking-wide flex-1 pl-2 relative z-10" data-id="element-52">
          <ZapIcon className="w-5 h-5 flex-shrink-0 animate-bounce" data-id="element-53" />
          <span className="leading-tight" data-id="element-54">Hablar con Mi Mentor</span>
        </a>
        <button onClick={() => setIsMinimized(true)} className="p-2 text-white hover:bg-white/20 rounded-full transition-colors flex-shrink-0 ml-2 relative z-10" aria-label="Cerrar" data-id="element-55">
          <XIcon className="w-5 h-5" data-id="element-56" />
        </button>
      </div>
    </div>;
}